import { useState } from "react";
import Lightbox from "react-awesome-lightbox";
import "react-awesome-lightbox/build/style.css";
import { useSelector } from "react-redux";
import { ImageUploadRemoveComponent } from "../CommonComponent/ImageUploadRemoveComponent";
import { getProfileVerificationAction } from "../../../redux/actions/ProfileVerificationAction";

const UploadDocuments = () => {
  const [isImageOpen, setIsImageOpen] = useState(false);
  const [imagePath, setImagePath] = useState("");

  const getProfileVerification = useSelector(
    (state) =>
      state?.profileVerificationReducer?.getProfileVerification
        ?.profileVerification
  );
  const aadharDetails = getProfileVerification?.uploadDocList?.filter(
    (ele) => ele.docType === "AADHAR"
  )?.[0];

  const centerRegistrationCertificateDetails =
    getProfileVerification?.uploadDocList?.filter(
      (ele) => ele.docType === "CENTREREGISTRATIONCERTIFICATE"
    )?.[0];

  const mouDetails = getProfileVerification?.uploadDocList?.filter(
    (ele) => ele.docType === "MOU"
  )?.[0];

  const mspDetails = getProfileVerification?.uploadDocList?.filter(
    (ele) => ele.docType === "MSP"
  )?.[0];

  const panDetails = getProfileVerification?.uploadDocList?.filter(
    (ele) => ele.docType === "PAN"
  )?.[0];

  return (
    <>
      <div className="upload-document">
        <h2>Upload Documents</h2>
      </div>
      <div className="row">
        <ImageUploadRemoveComponent
          imageDetails={aadharDetails}
          heading="Aadhar Card"
          docType={"AADHAR"}
          setIsImageOpen={setIsImageOpen}
          setImagePath={setImagePath}
          getPageAPI={getProfileVerificationAction}
          required={true}
          fileSize={2097152}
        />
        <ImageUploadRemoveComponent
          imageDetails={panDetails}
          heading="Pan Card"
          docType={"PAN"}
          setIsImageOpen={setIsImageOpen}
          setImagePath={setImagePath}
          getPageAPI={getProfileVerificationAction}
          required={true}
          fileSize={2097152}
        />
        <ImageUploadRemoveComponent
          imageDetails={mspDetails}
          heading="MSP Sheet Duly Filled"
          docType={"MSP"}
          setIsImageOpen={setIsImageOpen}
          setImagePath={setImagePath}
          getPageAPI={getProfileVerificationAction}
          required={false}
          fileSize={2097152}
        />
        <ImageUploadRemoveComponent
          imageDetails={centerRegistrationCertificateDetails}
          heading="Centre Registration Certificate"
          docType={"CENTREREGISTRATIONCERTIFICATE"}
          setIsImageOpen={setIsImageOpen}
          setImagePath={setImagePath}
          getPageAPI={getProfileVerificationAction}
          required={true}
          fileSize={2097152}
        />
        <ImageUploadRemoveComponent
          imageDetails={mouDetails}
          heading="Signed MOU"
          docType={"MOU"}
          setIsImageOpen={setIsImageOpen}
          setImagePath={setImagePath}
          getPageAPI={getProfileVerificationAction}
          required={false}
          fileSize={12777216}
        />
      </div>
      {isImageOpen === true && (
        <Lightbox
          image={imagePath}
          title="Image Description"
          onClose={() => setIsImageOpen(false)}
        />
      )}
    </>
  );
};

export default UploadDocuments;
